// Haptic feedback utility for mobile devices
export function triggerHapticFeedback(type: 'light' | 'medium' | 'heavy' = 'light'): void {
  // Check if the device supports vibration
  if (!navigator.vibrate) {
    return;
  }

  // Different vibration patterns for different feedback types
  const patterns = {
    light: 10,
    medium: 20,
    heavy: 30
  };

  try {
    navigator.vibrate(patterns[type]);
  } catch (error) {
    // Silently fail if vibration is not supported or blocked
    console.debug('Haptic feedback not available:', error);
  }
}

// Trigger haptic feedback for specific interactions
export const hapticFeedback = {
  // Light tap feedback for button clicks
  tap: () => triggerHapticFeedback('light'),
  
  // Medium feedback for selections
  select: () => triggerHapticFeedback('medium'),
  
  // Heavy feedback for important actions
  impact: () => triggerHapticFeedback('heavy'),
  
  // Success pattern
  success: () => {
    if (navigator.vibrate) {
      navigator.vibrate([10, 50, 10]);
    }
  },
  
  // Error pattern
  error: () => {
    if (navigator.vibrate) {
      navigator.vibrate([20, 100, 20, 100, 20]);
    }
  }
};